import ReconnectingWeb from 'reconnecting-websocket'
import {
  Configuration,
  GeneralApi,
  ManualPublicApi,
  ManualPrivateApi,
  NewsApi,
  StorageApi,
  TenantApi,
  IndexApi,
} from './autogenerated'
import { WebsocketEventEmitter } from './classes/WebsocketEventEmitter'
import { tenantProxy } from './wrapper'

const socket = new ReconnectingWeb(`${window.document.location.origin.replace('http', 'ws')}/api/ws/`, undefined, { startClosed: true, reconnectionDelayGrowFactor: 1 })

export * from './autogenerated/models'

let curAccessToken: null | string = null
let curTenant: string = 'test'
let curdisplayName: string | null = null

export function authentication(accessToken: string, tenant: string, displayName: string): void {
  curAccessToken = accessToken
  curTenant = tenant
  socket.reconnect()
  curdisplayName = displayName
}

const configuration = new Configuration({
  basePath: '/api',
  headers: {
    // @ts-expect-error Wrong typing
    get token() {
      return curAccessToken ?? undefined
    },
  },
})

export const storageApi = tenantProxy(new StorageApi(configuration), () => curTenant)
export const storageAuthlessApi = new StorageApi(configuration)
export const tenantApi = tenantProxy(new TenantApi(configuration), () => curTenant)
export const generalApi = tenantProxy(new GeneralApi(configuration), () => curTenant)
export const manualPrivateApi = tenantProxy(new ManualPrivateApi(configuration), () => curTenant)
export const manualPublicApi = new ManualPublicApi(configuration)
export const newsApi = tenantProxy(new NewsApi(configuration), () => curTenant)
export const indexApi = tenantProxy(new IndexApi(configuration), () => curTenant)

export const websocket = new WebsocketEventEmitter(socket, {
  get token() {
    return curAccessToken ?? ''
  },
  get displayName() {
    return curdisplayName ?? ''
  },
  get tenant() {
    return curTenant
  },
})
